export default __webpack_public_path__ + "static/media/Wall_Conveyor_Perpendicular_Grey.256.b00cd7fc.png";